import React from "react"
//import { BrowserRouter } from "react-router-dom"
//import { AuthProvider } from "./context/AuthContext"
//import Routes from "./Routes"
import Header from "./pages/Header"
import { AuthProvider } from "./context/AuthProvider";
import {BrowserRouter, Routes, Route,Navigate, Outlet} from 'react-router-dom';
import Search from "./pages/Search";
import HomePage from "./pages/HomePage";
import { useAuth } from "./context/AuthProvider";
const App:React.FC = () => {

  const PrivateRoutes = () => {
    const { authenticated } = useAuth();
   
  
    if(!authenticated) return <Navigate to='/home' replace />
  
    return <Outlet />
  }

  
  return (
    <BrowserRouter>
      
        <nav>
          <Header  />
        </nav>

        <Routes >
        <Route path='/home' element={<HomePage />} />

      <Route element={<PrivateRoutes />}>
        <Route path='/' element={<Search />} />
        <Route path='/search' element={<Search />} />
      </Route>


        </Routes>
      
    </BrowserRouter>
  )
}

export default App